import { SocieteProfilSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const SocieteProfilModel: SelectorModel = {
  name: 'societeProfils',
  getSelector: SocieteProfilSelectors.selectAllSocieteProfilsDictionary,
  isReady: SocieteProfilSelectors.selectIsReadySocieteProfil
};
